export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Recommended For You",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/full-cream-milk.png",
      title: "Yarra Farm Fresh UHT Milk 1L",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Buy Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/product/penang-delivery-e-pasar/farm-fresh-uht-yarra-full-cream-milk-1kg-penang-delivery"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/mushroom-seafood-tofu.png",
      title: "MUSHROOM Seafood Tofu 160G",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Buy Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/product/penang-delivery-e-pasar/mushroom-seafood-tofu-160g-penang-delivery"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/massimo-fine-wholemeal.png",
      title: "MASSIMO Fine Wholemeal Loaf ±500g",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Buy Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/product/penang-delivery-e-pasar/massimo-fine-wholemeal-loaf-500g-penang-delivery"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/salute-brand-kopi.png",
      title: "Salute Brand 2 in 1 Kopi ‘O’  20's x 30g",
      subtitle: "",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "Buy Now",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/product/penang-delivery-salute-brand-coffee-and-tea/salute-brand-2-in-1-kopio20sx30g-hai-jun-pai-2-he-1-ga-fei-wu-20-xiao-bao-x30-ke-penang-delivery"
    }
  ],
}
